/* @flow */
function decode(token: string): Object {
  const contents = token.split('.')[1];
  return contents ? JSON.parse(window.atob(contents)) : {};
}

export default {
  decode,
};
